module.exports = __webpack_public_path__ + "static/media/logo_school.51210290.png";